module.exports = __webpack_public_path__ + "static/img/tile-9.a2833d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tile-9.jpg
// module id = 1543
// module chunks = 180